import moment from 'moment-with-locales-es6';
import { earthRadius } from '../constants/constants';

export function getRandomElement(array) {
    const randomIndex = Math.floor(Math.random() * array.length);
    return array[randomIndex]
}

export function pointsAreEqual(point1, point2) {
    return (point1[0] === point2[0] && point1[1] === point2[1])
}

export function polygonsAreEqual(polygon1, polygon2) {
    if (polygon1.length !== polygon2.length) return false
    for (let i = 0; i < polygon1.length; i++) {
        let point1 = polygon1[i]
        let point2 = polygon2[i]
        if (!pointsAreEqual(point1, point2)) {
            return false
        }
    }
    return true
}

export function GpsPointsAreEqual(gpsPoints, gpsPointsToCompare) {
    let gpsPoints1 = Object.values(gpsPoints)
    let gpsPoints2 = Object.values(gpsPointsToCompare)
    if (gpsPoints1.length !== gpsPoints2.length) return false
    for (let i = 0; i < gpsPoints1.length; i++) {
        let point1 = [gpsPoints1[i].attributes.latitude, gpsPoints1[i].attributes.longitude]
        let point2 = [gpsPoints2[i].attributes.latitude, gpsPoints2[i].attributes.longitude]
        if (!pointsAreEqual(point1, point2)) return false
        
    }
    return true
}

export function mixRgbColors(colors) {
    if (colors.length === 0) return 'white'
    colors = colors.map(stringRgbColorToArray)
    let mixedColors = colors.reduce(sumRgbColors)
    let r = Math.round(mixedColors[0] / colors.length)
    let g = Math.round(mixedColors[1] / colors.length)
    let b = Math.round(mixedColors[2] / colors.length)
    return `rgb(${r}, ${g}, ${b})`
}

const stringRgbColorToArray = (color) => {
    let rgb = color.substring(4, color.length - 1).split(',')
    rgb = rgb.map(value => { return parseInt(value) })
    return rgb
}

const sumRgbColors = (prevColor, currentColor) => {
    let r = prevColor[0] + currentColor[0]
    let g = prevColor[1] + currentColor[1]
    let b = prevColor[2] + currentColor[2]
    return [r, g, b]
}

export function parseDateFromNow(date) {
    moment.locale(window.lang);
    return moment(date).startOf('seconds').fromNow();
}

export function parseDate(date, formatType='LL') {
    return moment(date).format(formatType);
}

export function getActualDatetime() {
    return moment().format('YYYY-MM-DD HH:mm:ss');
}

export function getDaysDiffBetweenDates(firstDate, secondDate) {
    return moment(secondDate).diff(firstDate, 'days')
}

export function dateIsOlderThanToday(targetDate) {
    return moment(targetDate).isBefore(moment(), 'day');
}

export function addDaysToDate(date, daysToAdd) {
    date.setDate(date.getDate() + daysToAdd);
    return date;
}

export function mergeArrays(array1, array2) {
    let mergedArray = [...array1]
    for (const value of array2) {
        if (!mergedArray.includes(value)) {
            mergedArray.push(value)
        }
    }
    return mergedArray
}

export function getElementData(elementsData, elementId, defaultValue=null) {
    if (!elementId) return defaultValue;
    let elementData = elementsData[elementId.toString()];
    if (elementData) {
        return elementData;
    }
    return defaultValue;
}

export function arraysHaveAnyMatch(array1, array2) {
    for (const value of array1) {
        if (array2.indexOf(value) !== -1) {
            return true;
        }
    }
    return false;
}

export function arraysHaveSameValues(array1, array2) {
    if (array1.length !== array2.length) return false;
    for (const value of array1) {
        if (array2.indexOf(value) === -1) return false;
    }
    return true;
}

export function removeDuplicates(array) {
    return [...new Set(array)];
}

export function calculateAreaFromPolygon(coords, projectCenter) {
    let area = 0;
    for (let i = 0; i < coords.length; i++) {
      const [x1, y1] = parseCoordinatePointToMeters(coords[i], projectCenter);
      const [x2, y2] = parseCoordinatePointToMeters(coords[(i + 1) % coords.length], projectCenter);
      area += x1 * y2 - x2 * y1;
    }
    return Math.abs(area) / 2;
}

export function parseCoordinatePointToMeters(point, projectCenter) {
    const centerLongitude = projectCenter[0];
    const centerLatitude = projectCenter[1];
    const longitude = point[0];
    const latitude = point[1];
    const centerY = ((latitude / (180 / Math.PI)) - (centerLatitude / (180 / Math.PI))) * earthRadius;
    const centerX = ((longitude * Math.cos(centerLatitude  * Math.PI / 180) / (180 / Math.PI)) - (centerLongitude * Math.cos(centerLatitude  * Math.PI / 180) / (180 / Math.PI))) * earthRadius;
    return [centerX, centerY];
}

export function getDistanceBetweenTwoPoints(point1, point2) {
    const a = point1[0] - point2[0];
    const b = point1[1] - point2[1];
    const c = Math.sqrt( a*a + b*b );
    return c;
}

export function toDataURL(url, callback){
    var xhr = new XMLHttpRequest();
    xhr.open('get', url);
    xhr.responseType = 'blob';
    xhr.onload = function(){
        var fr = new FileReader();
        
        fr.onload = function(){
            callback(this.result);
        };
        
        fr.readAsDataURL(xhr.response); // async call
    };
    xhr.send();
}

export function getWindowPercentageInPx(percentage) {
    const minValue = Math.min(window.innerWidth, window.innerHeight);
    return minValue * percentage;
}

export function objectIsNotEmpty(object) {
    return Object.keys(object).length > 0;
}

export function attributeHasValueinElementsData(elementsData, attribute) {
    for (const elementData of Object.values(elementsData)) {
        const value = elementData.attributes[attribute];
        if (value?.length !== undefined && value.length === 0) continue;
        if (value) {
            return true;
        }
    }
    return false;
}

export function shortString(string, length=30, suffix='...') {
    if (string.length > length) {
        return string.substring(0, length).concat(suffix);
    }
    return string
}

export function fixAndToLocaleString(number) {
    let formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    return formatter.format(number);
}

export function previousMonth(date) {
    let newDate = new Date(date);
    newDate.setMonth(newDate.getMonth() - 1);
    return newDate.toISOString().split('T')[0]
}

export function nextYear(date) {
    let newDate = new Date(date);
    newDate.setFullYear(newDate.getFullYear() + 1);
    return newDate;
}

export function daysDifferenceBetweenDates(date1, date2) {
    const firstDate = new Date(date1);
    const secondDate = new Date(date2);

    const differenceInMilliseconds = firstDate - secondDate;
    const milisecondsPerDay = 1000 * 60 * 60 * 24;

    const daysDiference = Math.abs(differenceInMilliseconds / milisecondsPerDay);
    return daysDiference;
}

export function getDatesBetweenDates(initDate, endDate) {
    const dates = [];
    let currentDate = new Date(initDate + 'T00:00:00');
    let lastDate = new Date(endDate + 'T00:00:00');
    while (currentDate <= lastDate) {
        dates.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
    }
  
    return dates;
}

export function groupUsersByCharge(users) {
    return users.reduce((result, user) => {
        const position = user.attributes.position;
        const idUser = user.id;
        if (!result[position]) {
            result[position] = [];
        }
        result[position].push(idUser);
        return result;
    }, {});
}